import { isCorpTenant } from "@capone/common";
import { Box, InputAdornment, TextField, Typography } from "@material-ui/core";
import clsx from "clsx";
import { Icon, IconName } from "halifax";
import { debounce } from "lodash-es";
import React from "react";
import { config } from "../../../../../../api/config";
import { ISetTripSearchQuery } from "../../../../actions/actions";

import "./styles.scss";

export const TripsTabTitle = ({
  title,
  subTitle,
  localSearchQuery,
  setLocalSearchQuery,
  setTripSearchQuery,
  isMobile,
  isXmodRedesign = false,
}: {
  title: string;
  subTitle: string;
  localSearchQuery: string;
  setLocalSearchQuery: (query: string) => void;
  setTripSearchQuery: (searchQuery: string) => ISetTripSearchQuery;
  isMobile: boolean;
  isXmodRedesign?: boolean;
}) => {
  const debouncedSetSearchQuery = debounce(setTripSearchQuery, 500);

  return (
    <Box
      className={clsx("trips-tab-title-container", {
        mobile: isMobile,
        xmod: isXmodRedesign,
      })}
    >
      <Box>
        <Typography component="h2" variant="h3" className="trips-tab-title">
          {title}
        </Typography>
        {!isXmodRedesign ? (
          <Typography variant="body2" className="trips-tab-subtitle">
            {subTitle}
          </Typography>
        ) : null}
      </Box>
      {isCorpTenant(config.TENANT) && (
        <Box className="trips-search-container">
          <TextField
            className="trips-search-input"
            variant="outlined"
            aria-label="search"
            id="search-input"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon name={IconName.MagnifyingGlass} />
                </InputAdornment>
              ),
            }}
            placeholder="Search by user, location, etc"
            onChange={(event) => {
              setLocalSearchQuery(event.target.value);
              debouncedSetSearchQuery(event.target.value);
            }}
            value={localSearchQuery}
          />
        </Box>
      )}
    </Box>
  );
};
